(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const storageKey = 'tf-cart-timer-v1';
    const duration = 10 * 60 * 1000;
    let memoryDeadline = null;

    function readDeadline() {
      try {
        const value = Number(window.localStorage.getItem(storageKey));
        memoryDeadline = Number.isFinite(value) && value > 0 ? value : null;
      } catch (_) {
        // Keep the timer working when browser storage is unavailable.
      }
      return memoryDeadline;
    }

    function writeDeadline(value) {
      memoryDeadline = value;
      try {
        if (value === null) window.localStorage.removeItem(storageKey);
        else window.localStorage.setItem(storageKey, String(value));
      } catch (_) {
        // The in-memory deadline survives drawer re-renders on this page.
      }
    }

    if (customElements.get('tf-cart-timer')) return;

    customElements.define('tf-cart-timer', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        if (Number(this.dataset.itemCount) === 0) {
          writeDeadline(null);
          return;
        }

        this.clock = this.querySelector('[data-cart-timer-clock]');
        this.activeMessage = this.querySelector('[data-cart-timer-active]');
        this.expiredMessage = this.querySelector('[data-cart-timer-expired]');
        if (!this.clock || !this.activeMessage || !this.expiredMessage) return;

        this.deadline = readDeadline();
        if (this.deadline === null) {
          this.deadline = Date.now() + duration;
          writeDeadline(this.deadline);
        }

        this.onStorage = (event) => {
          if (event.key !== storageKey && event.key !== null) return;
          this.deadline = readDeadline();
          this.start();
        };
        this.onWake = () => this.render();
        window.addEventListener('storage', this.onStorage);
        window.addEventListener('pageshow', this.onWake);
        document.addEventListener('visibilitychange', this.onWake);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        window.removeEventListener('storage', this.onStorage);
        window.removeEventListener('pageshow', this.onWake);
        document.removeEventListener('visibilitychange', this.onWake);
      }

      start() {
        this.stop();
        this.render();
        if (this.deadline !== null && this.deadline > Date.now()) {
          this.interval = window.setInterval(() => this.render(), 1000);
        }
      }

      stop() {
        window.clearInterval(this.interval);
        this.interval = null;
      }

      render() {
        if (this.deadline === null) {
          this.hidden = true;
          this.stop();
          return;
        }

        const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        this.clock.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
        this.activeMessage.hidden = seconds === 0;
        this.expiredMessage.hidden = seconds > 0;
        this.hidden = false;
        if (seconds === 0) this.stop();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
  if (!customElements.get('tfb-collection-total')) {
    customElements.define('tfb-collection-total', class extends HTMLElement {
      connectedCallback() {
        const sync = () => {
          const count = document.querySelector('.tfb-collection-count');
          if (count && this.textContent !== count.textContent) this.textContent = count.textContent;
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
        sync();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-editorial-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tf-trust-slider')) {
 customElements.define('tf-trust-slider', class extends HTMLElement {
  connectedCallback() {
   this.lifecycle?.abort();
   this.lifecycle = new AbortController();
   const signal = this.lifecycle.signal;
   this.track = this.querySelector('.tf-editorial__trust');
   this.items = Array.from(this.track?.children || []);
   if (this.items.length < 2) return;
   this.classList.add('is-ready');
   this.addEventListener('click', event => {
    const button = event.target.closest('[data-trust-step]');
    if (button && this.contains(button)) this.move(Number(button.dataset.trustStep));
   }, {signal});
   this.track.addEventListener('keydown', event => {
    if (!matchMedia('(max-width:749px)').matches) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
     event.preventDefault();
     this.move(event.key === 'ArrowRight' ? 1 : -1);
    }
   }, {signal});
   document.addEventListener('shopify:block:select', event => {
    const index = this.items.findIndex(item => item.dataset.trustBlock === event.detail?.blockId);
    if (index >= 0 && matchMedia('(max-width:749px)').matches) this.show(index);
   }, {signal});
  }
  move(step) {
   const bounds = this.track.getBoundingClientRect();
   const center = bounds.left + bounds.width / 2;
   let nearest = 0;
   let distance = Infinity;
   this.items.forEach((item, index) => {
    const rect = item.getBoundingClientRect();
    const delta = Math.abs(rect.left + rect.width / 2 - center);
    if (delta < distance) { distance = delta; nearest = index; }
   });
   this.show((nearest + step + this.items.length) % this.items.length);
  }
  show(index) {
   const track = this.track.getBoundingClientRect();
   const item = this.items[index].getBoundingClientRect();
   this.track.scrollBy({
    left: item.left + item.width / 2 - track.left - track.width / 2,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
   });
  }
  disconnectedCallback() { this.lifecycle?.abort(); }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tf-faq')) {
  customElements.define('tf-faq', class extends HTMLElement {
    connectedCallback() {
      this.onToggle = (event) => {
        const item = event.target;
        if (this.dataset.singleOpen !== 'true' || !item.matches('details.tf-faq__item') || !item.open) return;
        this.querySelectorAll('details.tf-faq__item[open]').forEach(other => {
          if (other !== item) other.open = false;
        });
      };
      this.onBlockSelect = (event) => {
        const item = event.target.closest('details.tf-faq__item');
        if (!item || !this.contains(item)) return;
        item.open = true;
        item.scrollIntoView({block: 'nearest', behavior: 'instant'});
      };
      this.addEventListener('toggle', this.onToggle, true);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }
    disconnectedCallback() {
      this.removeEventListener('toggle', this.onToggle, true);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tfb-header-countdown')) {
    class TfbHeaderCountdown extends HTMLElement {
      static deadlineFromInputs(date, time, timeZone) {
        const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date || '');
        const timeMatch = /^(\d{2}):(\d{2})$/.exec(time || '');
        if (!dateMatch || !timeMatch) return null;
        const [, year, month, day] = dateMatch.map(Number);
        const [, hour, minute] = timeMatch.map(Number);
        if (year < 1970 || month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59) return null;
        const wallTime = Date.UTC(year, month - 1, day, hour, minute, 0);
        const check = new Date(wallTime);
        if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return null;
        try {
          const formatter = new Intl.DateTimeFormat('en-GB', {
            timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
          });
          const localWallTime = (timestamp) => {
            const parts = Object.fromEntries(formatter.formatToParts(timestamp).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
            return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
          };
          let candidate = wallTime;
          for (let attempt = 0; attempt < 3; attempt += 1) {
            candidate += wallTime - localWallTime(candidate);
          }
          return localWallTime(candidate) === wallTime ? candidate : null;
        } catch {
          return null;
        }
      }

      static partsFor(deadline, now) {
        const total = Math.max(0, Math.ceil((deadline - now) / 1000));
        return {
          total,
          days: Math.floor(total / 86400),
          hours: Math.floor(total / 3600) % 24,
          minutes: Math.floor(total / 60) % 60,
          seconds: total % 60
        };
      }


      connectedCallback() {
        this.timer = this.querySelector('[data-countdown-timer]');
        this.message = this.querySelector('[data-countdown-message]');
        this.viewport = this.querySelector('[data-countdown-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-countdown-slide]'));
        this.units = Object.fromEntries(Array.from(this.querySelectorAll('[data-countdown-unit]')).map(node => [node.dataset.countdownUnit, node]));
        this.isEditor = this.dataset.designMode === 'true';
        this.currentSlide = -1;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        this.delay = Math.max(3000, Number(this.dataset.rotation) * 1000 || 5000);
        this.events = new AbortController();
        const listen = (target, event, callback) => target.addEventListener(event, callback, { signal: this.events.signal });
        this.resizeObserver = new ResizeObserver(() => this.syncSticky());
        this.resizeObserver.observe(this);
        this.deadline = TfbHeaderCountdown.deadlineFromInputs(this.dataset.date, this.dataset.time, this.dataset.timezone);
        this.showSlide(0, false);
        if (this.deadline === null) {
          this.dataset.state = 'invalid';
          if (this.isEditor) this.showMessage(this.dataset.date ? this.dataset.invalidMessage : this.dataset.setupMessage);
          else this.hidden = true;
          this.syncSticky();
          return;
        }
        const deadlineElement = this.querySelector('[data-countdown-end]');
        deadlineElement.dateTime = new Date(this.deadline).toISOString();
        deadlineElement.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'nl', {
          timeZone: this.dataset.timezone, dateStyle: 'long', timeStyle: 'short'
        }).format(this.deadline);
        listen(this, 'mouseenter', () => { this.hovered = true; this.stopRotation(); });
        listen(this, 'mouseleave', () => { this.hovered = false; this.startRotation(); });
        listen(this, 'focusin', () => { this.focused = true; this.stopRotation(); });
        listen(this, 'focusout', () => {
          window.setTimeout(() => {
            if (!this.isConnected) return;
            this.focused = this.contains(document.activeElement);
            this.startRotation();
          }, 0);
        });
        this.onVisibility = () => {
          this.stop();
          this.stopRotation();
          if (!document.hidden && this.update()) {
            this.interval = window.setInterval(() => this.update(), 1000);
            this.startRotation();
          }
        };
        listen(document, 'visibilitychange', this.onVisibility);
        this.onVisibility();
      }

      disconnectedCallback() {
        this.stop();
        this.stopRotation();
        window.clearTimeout(this.transitionTimeout);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        document.documentElement.style.setProperty('--tfb-countdown-offset', '0px');
      }

      stop() {
        if (this.interval) window.clearInterval(this.interval);
        this.interval = null;
      }

      stopRotation() {
        if (this.rotationInterval) window.clearInterval(this.rotationInterval);
        this.rotationInterval = null;
      }

      startRotation() {
        this.stopRotation();
        if (this.dataset.state !== 'running' || this.slides.length < 2 || document.hidden || this.reducedMotion || this.hovered || this.focused) return;
        this.rotationInterval = window.setInterval(() => this.showSlide((this.currentSlide + 1) % this.slides.length), this.delay);
      }

      showSlide(index, animate = true) {
        if (!this.slides[index] || index === this.currentSlide) return;
        window.clearTimeout(this.transitionTimeout);
        const previous = this.slides[this.currentSlide];
        this.slides.forEach((slide, i) => {
          slide.classList.remove('is-active', 'is-leaving');
          slide.setAttribute('aria-hidden', String(i !== index));
          slide.inert = i !== index;
        });
        if (previous && animate) previous.classList.add('is-leaving');
        this.slides[index].classList.add('is-active');
        this.currentSlide = index;
        this.dataset.slide = String(index + 1);
        if (previous) this.transitionTimeout = window.setTimeout(() => previous.classList.remove('is-leaving'), 650);
      }

      syncSticky() {
        const height = this.dataset.sticky === 'true' && !this.hidden ? Math.ceil(this.getBoundingClientRect().height) : 0;
        document.documentElement.style.setProperty('--tfb-countdown-offset', height + 'px');
      }

      showMessage(text) {
        this.timer.hidden = true;
        this.viewport.hidden = true;
        this.message.textContent = text || '';
        this.message.hidden = false;
        this.hidden = false;
        this.stopRotation();
        this.syncSticky();
      }

      update() {
        const parts = TfbHeaderCountdown.partsFor(this.deadline, Date.now());
        for (const [unit, node] of Object.entries(this.units)) {
          const next = String(parts[unit]).padStart(2, '0');
          if (node.textContent !== next) node.textContent = next;
        }
        if (parts.total === 0) {
          this.stop();
          this.stopRotation();
          this.dataset.state = 'expired';
          if (this.dataset.expiry === 'hide' && !this.isEditor) this.hidden = true;
          else if (this.dataset.expiry === 'zero') {
            this.hidden = false;
            this.viewport.hidden = false;
            this.timer.hidden = false;
            this.message.hidden = true;
            this.showSlide(this.slides.length - 1, false);
          } else this.showMessage(this.dataset.expiredMessage);
          this.syncSticky();
          return false;
        }
        this.dataset.state = 'running';
        this.hidden = false;
        this.viewport.hidden = false;
        this.timer.hidden = false;
        this.message.hidden = true;
        this.syncSticky();
        return true;
      }
    }
    customElements.define('tfb-header-countdown', TfbHeaderCountdown);
  }

  } catch(e) { console.error(e); }
})();
})();
